import initLpuLoyaltyProgram from 'src/components/common/LpuLoyaltyProgram'

initLpuLoyaltyProgram()

document.addEventListener('mountLpuLoyaltyProgram', initLpuLoyaltyProgram)
